import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { BankTransactionEntityService } from '@views/pages/apps/settings/bank-transaction/service/bank-transaction-entity.service';

@Injectable()
export class BankTransactionResolver implements Resolve<boolean> {

    constructor(private bankTransactionEntityService: BankTransactionEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.bankTransactionEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.bankTransactionEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
